import routePlanning from "./routePlanning.component";
import routePlanningUrls from "./routePlanning.urls";
import RoutePlanningTransforms from "./routePlanning.transforms";

const routePlanningModule = angular
  .module("app.components.routePlanning", [])
  .component("routePlanningPage", routePlanning)
  .service("RoutePlanningTransforms", RoutePlanningTransforms)
  .config(routePlanningUrls);

export default routePlanningModule;



// WEBPACK FOOTER //
// ./src/pages/routePlanning/routePlanning.module.js